import { render, staticRenderFns } from "./PaihMigratorSettings.vue?vue&type=template&id=095ead12&scoped=true&"
import script from "./PaihMigratorSettings.vue?vue&type=script&lang=js&"
export * from "./PaihMigratorSettings.vue?vue&type=script&lang=js&"
import style0 from "./PaihMigratorSettings.vue?vue&type=style&index=0&id=095ead12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095ead12",
  null
  
)

export default component.exports